import store from "@/store";


export let filters = {
    filters: {
        price: {
            minValue: null,
            maxValue: null,
        },
        search: '',
        category: [],
        category_column: '',
        brand: [],
        brand_column: '',
        feature: [],
        is_digital: '',
        sort: '',
        per_page: 12,
        quantity: 2,
        language: '',
        multiple_store: [],
        store_column: '',
        product: '',
        reservation: '',
        item_type: '',
        feature_operator: 'or',
        tag: [],
    }
}

/*
get items from  Filters component data state and create a query string for filters data
        supported filters:
        - brands
        - category
        - status
        - is_digital
        - price
        - quantity
        - language

        example:
            // put your module name instead of `Content`
            this.$store.commit('Content/setFilters', {key: 'language', value: 'fr'})
            this.$store.commit('Content/setFilters', {key: 'category', value: []})

*/
export const queryBuilder = (filters) => {
    let query = ''
    const keys = Object.keys(filters);
    for (let i in keys) {
        const key = keys[i]
        const value = filters[key];
        if (key == 'price' && (value.minValue != null && value.maxValue != null)) {
            query += `${key}=${value.minValue}-${value.maxValue}&`
        }

        const validFilter = ['search', "is_digital", "status", 'sort', 'per_page', 'quantity', 'language',
            'brand_column', 'category_column', 'store_column', 'product', 'reservation', 'item_type', 'feature_operator'];

        if (validFilter.indexOf(key) > -1) {
            query += `${key}=${value}&`
        }
        if (value.length > 0 && typeof value != 'string') { // check selected key have value
            const valueToString = value.join(',')
            query += `${key}=${valueToString}&`
        }
    }
    return query
}

/*
resetFilters documentation:
this function reset filters of selected module.
except parameter options:
you can define exception for filters of module to not be reset.
if pass empty array [] will reset all of the filters of selected module.
NOTE: if you want reset all of the filters make sure to define language later.
*/
export const resetFilters = (module = 'product', except = ['language']) => {
    const filtersItem = filters.filters
    const moduleName = module.charAt(0).toUpperCase() + module.slice(1);
    Object.keys(filtersItem).forEach(item => {
        if (except.indexOf(item) === -1) {
            store.commit(`${moduleName}/setFilters`, {key: item, value: filtersItem[item]});
        }
    })
}
